module.exports = __webpack_public_path__ + "@/assets/img/04.b9a1f743.svg";